import React, { useMemo } from 'react'
import { HistorialReplanificacionVacaciones, HistorialSolicitudesVacaciones, PlanificacionesMensuales, VacacionesGozadasCard } from './TypesSolicitudVacaciones'
import { Card, CardTitle, CardBody, CardFooter } from "reactstrap";
import { DownloadDocument } from 'helpers/files';
import { authenticationService } from 'services/authentication.service';



type PropsCardHistorialSolicitudesVacaciones = {
    informacion: HistorialSolicitudesVacaciones;
    color: string;
    verDetalleHistorico: (anio: number) => Promise<void>,
    historialReplanificacion: PlanificacionesMensuales[] | undefined
}

export default function CardHistorialSolicitudesVacaciones(props: PropsCardHistorialSolicitudesVacaciones) {

    const { key, value } = props.informacion;
    const { diasFindeSemana, diasOrdinariosGanados, totalDias, totalDiasOrdinariosGozados } = value;
    const mensajeCard2018 = "A partir del 2019 para el personal de LOSEP y LOES se considerarán para el proceso de vacaciones 22 días ordinarios y 8 días de fin de semana; y para el personal de Código de trabajo 11 días ordinarios y 4 días de fin de semana."

    async function HandleClickVerDetalleHistorial(anioDeseado: number) {
        if (typeof (props.verDetalleHistorico) === "function") await props.verDetalleHistorico(anioDeseado);
    }

    const componenteVerDetalle = useMemo(() => {
        return (<div className="float-right">
            <span className='verDetalleHistorialSolicVac'>Ver Detalle</span>
            <span>
                <i className="fa-solid fa-eye verDetalleHistorialSolicVac ml-2" onClick={() => HandleClickVerDetalleHistorial(key)}></i>
            </span>
        </div>)

    }, [props.verDetalleHistorico])


    const contenidoCardHistorialMeses = (vacacionesGozadas: VacacionesGozadasCard[], anio: number) => {
        if (anio === 2018) {
            return undefined;
        }
        function generarHTMLColumnasMeses(vac: VacacionesGozadasCard[]) {

            const resultadoHTML = vac.map((valgoz, indvac) => {
                return (

                    <React.Fragment key={"detalleHTMLcolumnasMeses " + indvac}>
                        <div className='rowContenidoMesesSolicitudes'>
                            <div className='nombres_campos_meses'>
                                <span>{valgoz.key}</span>
                            </div>
                            <div className='detalle_valores_meses'>
                                <div style={{ display: "flex", flexDirection: "row" }}>
                                    <div >{valgoz.value} </div> <div className='keyscardHistorial ml-1'>{valgoz.value > 1 ? "días" : "día"}</div>
                                </div>
                            </div>
                        </div>
                    </React.Fragment>

                )
            })

            return resultadoHTML;

        }
        const sizeDetalles = vacacionesGozadas.length;
        var mesesColumna1: any = undefined;
        var mesesColumna2: any = undefined;
        if (sizeDetalles > 6) {
            var vacacionesSplit = vacacionesGozadas.slice(0, 6);
            mesesColumna1 = generarHTMLColumnasMeses(vacacionesSplit)
            vacacionesSplit = vacacionesGozadas.slice(6);
            mesesColumna2 = generarHTMLColumnasMeses(vacacionesSplit);
        }
        else {
            mesesColumna1 = generarHTMLColumnasMeses(vacacionesGozadas);
        }
        const contenidoCard = (
            <React.Fragment>
                <div className="parentContenidoSolicitudes1">

                    {
                        mesesColumna1
                    }

                </div>
                <div className='parentContenidoSolicitudes2'>
                    {
                        mesesColumna2
                    }
                </div>

            </React.Fragment>
        )
        return contenidoCard;
    }

    const contenidoCardHistorialReplanificacionMeses = (vacacionesGozadas: PlanificacionesMensuales[], anio: number) => {

        const token = authenticationService.currentUserValue.token;

        if (anio === 2018) {
            return undefined;
        }
        function generarHTMLColumnasMeses(vac: PlanificacionesMensuales[]) {

            const resultadoHTML = vac.map((valgoz, indvac) => {
                return (

                    <React.Fragment key={"detalleHTMLcolumnasMeses " + indvac}>
                        <div className='rowContenidoMesesSolicitudes'>
                            <div className='nombres_campos_meses'>
                                <span>{valgoz.key}</span>
                            </div>
                            <div className='detalle_valores_meses'>
                                <div style={{ display: "flex", flexDirection: "row" }}>
                                    {
                                        valgoz.value.map((v, i) => {
                                            const classNameMargin = i === 0 ?"ml-5" : "ml-2"
                                            return (
                                                <span key={"detalleValoresMeses " + i} onClick={() => DownloadDocument(v, token, "solicitud replanificación.pdf")} className={`iconDownloadSolicitudReplanif ${classNameMargin}`}>
                                                    <i key={"pdfIconDownloadReplanificacion " + i + "anio" + anio + "mes " + valgoz.key} className='fas fa-file-pdf mt-auto ' >

                                                    </i>
                                                </span>

                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    </React.Fragment>

                )
            })

            return resultadoHTML;

        }
        const sizeDetalles = vacacionesGozadas.length;
        var mesesColumna1: any = undefined;
        var mesesColumna2: any = undefined;
        if (sizeDetalles > 6) {
            var vacacionesSplit = vacacionesGozadas.slice(0, 6);
            mesesColumna1 = generarHTMLColumnasMeses(vacacionesSplit)
            vacacionesSplit = vacacionesGozadas.slice(6);
            mesesColumna2 = generarHTMLColumnasMeses(vacacionesSplit);
        }
        else {
            mesesColumna1 = generarHTMLColumnasMeses(vacacionesGozadas);
        }
        const contenidoCard = (
            <React.Fragment>
                <div className='mb-5'>
                    <div className="parentContenidoSolicitudes1">

                        {
                            mesesColumna1
                        }

                    </div>
                    <div className='parentContenidoSolicitudes2'>
                        {
                            mesesColumna2
                        }
                    </div>
                </div>


            </React.Fragment>
        )
        return contenidoCard;
    }



    return (
        <>
            <Card className="cardHistorialVacaciones">
                <CardTitle className="cardHeaderHistorialSolicitudesVacaciones" style={{ backgroundColor: props.color }}>
                    <div>
                        {key === 2018 ? "Saldo a Dic 2018" : "Vacaciones " + key}
                    </div>
                </CardTitle>

                <CardBody>
                    <div id="container-HistorialSolicitudesVacaciones" className='container_informacion_historial'>
                        <div >
                            <span><strong>Días de vacaciones ganadas</strong></span>
                        </div>
                        <div className='container_contenido_historial'>

                            <div className='nombre_campos'>
                                <span>{"Días Ordinarios: "}</span>
                            </div>
                            <div className='detalle_valores'>

                                <div style={{ width: "60%" }}><strong >{Number(diasOrdinariosGanados).toFixed(2)}</strong></div>
                            </div>
                        </div>

                        <div className='container_contenido_historial'>

                            <div className='nombre_campos'>
                                <span>{"Días de fin de semana: "}</span>
                            </div>
                            <div className='detalle_valores'>
                                <div style={{ width: "60%" }}><strong >{Number(diasFindeSemana).toFixed(2)}</strong></div>
                            </div>
                        </div>

                        <div className='container_contenido_historial'>
                            <div className='nombre_campos'>
                                <span>{"Total de días: "}</span>
                            </div>
                            <div className='detalle_valores'>
                                <div style={{ width: "60%" }}><strong >{Number(totalDias).toFixed(2)}</strong></div>

                            </div>
                        </div>
                    </div>

                    {
                        key === 2018 &&
                        <p className='mt-2 text-justify'>{mensajeCard2018}</p>
                    }

                    {totalDiasOrdinariosGozados !== null && totalDiasOrdinariosGozados > 0 && key !== 2018 &&
                        <>

                            <div className="mt-4">
                                <strong >Vacaciones Gozadas en días ordinarios:  {totalDiasOrdinariosGozados}</strong>
                            </div>




                        </>

                    }

                    {props.historialReplanificacion !== undefined && props.historialReplanificacion.length > 0 &&
                        <>
                            <div className='mt-2'><strong>Solicitudes Justif/Reprogr </strong></div>
                            <div className="containerParentVacacionesSolicitudes">
                                {contenidoCardHistorialReplanificacionMeses(props.historialReplanificacion, key)}
                            </div>
                        </>

                    }



                </CardBody>
                {
                    key !== 2018 &&
                    (<CardFooter>

                        {componenteVerDetalle}

                    </CardFooter>)
                }

            </Card>
        </>
    )
}
